/**
 * @generated SignedSource<<2c889904d9809df8db2bfaa6b1e6b434>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EntityBadgeWithdrawButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type EntityBadgeWithdrawButtonMutation$data = {
  readonly withdrawBadge: string;
};
export type EntityBadgeWithdrawButtonMutation = {
  response: EntityBadgeWithdrawButtonMutation$data;
  variables: EntityBadgeWithdrawButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": (v1/*:: as any*/),
  "kind": "ScalarField",
  "name": "withdrawBadge",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EntityBadgeWithdrawButtonMutation",
    "selections": [
      (v2/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EntityBadgeWithdrawButtonMutation",
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "withdrawBadge",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "918dc4b42759aa6a0669378325ae9085",
    "id": null,
    "metadata": {},
    "name": "EntityBadgeWithdrawButtonMutation",
    "operationKind": "mutation",
    "text": "mutation EntityBadgeWithdrawButtonMutation(\n  $id: ID!\n) {\n  withdrawBadge(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "abcf6922d58b71680e847eb956cb58b2";

export default node;
